import { FC, memo, useLayoutEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../dialog";
import { MediaContentDataType } from "@/types";

type PreviewContentDialogPropsType = {
  triggerStyle?: string;
  selectedMediaContent?: MediaContentDataType | null;
  setSelectedMediaContent: (entityData: MediaContentDataType | null) => void;
};

const PreviewContentDialog: FC<PreviewContentDialogPropsType> = ({
  selectedMediaContent,
  setSelectedMediaContent,
}) => {
  const [iframeStateRef, setIframeStateRef] = useState<any | null>(null);

  const isDocument =
    selectedMediaContent &&
    (selectedMediaContent.media_type === "document" ||
      (selectedMediaContent.media_type === "shared_resource" &&
        selectedMediaContent.original_media_type === "document"));

  const isVideo =
    selectedMediaContent &&
    (selectedMediaContent.media_type === "video" ||
      (selectedMediaContent.media_type === "shared_resource" &&
        selectedMediaContent.original_media_type === "video"));

  const isExternalSource =
    selectedMediaContent &&
    (selectedMediaContent.media_type === "external_source" ||
      (selectedMediaContent.media_type === "shared_resource" &&
        selectedMediaContent.original_media_type === "external_source"));

  useLayoutEffect(() => {
    if (isExternalSource && iframeStateRef) {
      iframeStateRef.credentialless = true;
      iframeStateRef.src = `${selectedMediaContent.metadata?.link}#toolbar=0&navpanes=0`;
    }
  }, [isExternalSource, selectedMediaContent, iframeStateRef]);

  return (
    <Dialog
      open={!!selectedMediaContent}
      onOpenChange={(open) => {
        if (!open) {
          setSelectedMediaContent(null);
        }
      }}
    >
      <DialogContent
        hideDefaultCloseBtn
        className="flex flex-col w-11/12 sm:max-w-full sm:max-h-full h-5/6 overflow-hidden"
      >
        <DialogHeader>
          <DialogTitle>{selectedMediaContent?.name}</DialogTitle>
        </DialogHeader>
        <div className="flex flex-1 flex-col overflow-hidden">
          {/* === display document === */}
          {isDocument && (
            <div className="relative w-full h-full flex flex-1 items-center justify-center">
              <iframe
                title="document"
                src={`/pdfjs-5.2.133-dist/web/viewer.html?file=${encodeURIComponent(
                  selectedMediaContent?.blob_url || ""
                )}`}
                width="100%"
                height="100%"
              />
            </div>
          )}
          {/* === display external source === */}
          {isExternalSource && (
            <iframe
              ref={(ref) => setIframeStateRef(ref)}
              allow="cross-origin-isolated"
              sandbox="allow-scripts allow-top-navigation"
              title="external source"
              width="100%"
              height="100%"
            />
          )}
          {/* === display video === */}
          {isVideo && (
            <video
              crossOrigin="anonymous"
              width="100%"
              height="100%"
              controls
              controlsList="nodownload"
              onContextMenu={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
              preload="none"
              style={{
                backgroundColor: "#cfcfcf",
                borderRadius: "4px",
                maxHeight: "100%",
                width: "100%",
                height: "100%",
              }}
            >
              <source
                src={
                  selectedMediaContent.orig_blob_url ||
                  selectedMediaContent.blob_url
                }
                type="video/mp4"
              />
            </video>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default memo(PreviewContentDialog);
